import React from "react";
import {
  Avatar as MuiAvatar,
  AvatarProps as MuiAvatarProps,
} from "@mui/material";

const PALETTE = [
  "#E11D48",
  "#7C3AED",
  "#2563EB",
  "#059669",
  "#D97706",
  "#DB2777",
  "#0891B2",
  "#65A30D",
];

const colorFromSeed = (seed: string): string => {
  if (!seed) return PALETTE[0];
  const idx = seed.split("").reduce((acc, ch) => acc + ch.charCodeAt(0), 0);
  return PALETTE[idx % PALETTE.length];
};

const initialsFromName = (name: string): string => {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  if (parts.length === 1) return parts[0][0]?.toUpperCase() ?? "?";
  return `${parts[0][0] ?? ""}${parts[parts.length - 1][0] ?? ""}`.toUpperCase();
};

export interface AvatarProps extends Omit<MuiAvatarProps, "children"> {
  name?: string;
  firstName?: string;
  lastName?: string;
  initials?: string;
  color?: string;
  size?: number;
}

const Avatar: React.FC<AvatarProps> = ({
  name,
  firstName,
  lastName,
  initials,
  color,
  size = 40,
  sx,
  ...props
}) => {
  const resolvedName = name ?? [firstName, lastName].filter(Boolean).join(" ");
  const resolvedInitials = initials ?? initialsFromName(resolvedName || "?");
  const resolvedColor = color ?? colorFromSeed(resolvedName);

  return (
    <MuiAvatar
      sx={{
        width: size,
        height: size,
        fontSize: size * 0.4,
        fontWeight: 600,
        backgroundColor: resolvedColor,
        color: "#fff",
        ...sx,
      }}
      {...props}
    >
      {resolvedInitials}
    </MuiAvatar>
  );
};

export default Avatar;
